import { useState } from "react";
import { Row } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { HiOutlineListBullet, HiOutlinePencilSquare, HiOutlineTrash } from "react-icons/hi2";

import { ListType } from "@/types/List.type";
import { ContextMenuContent, ContextMenuItem } from "@/components/atoms/ContextMenu";
import Modal from "@/components/molecules/Modal";
import ConvertListModal from "@/components/molecules/table/modals/ConvertListModal";
import DeleteListModal from "@/components/molecules/table/modals/DeleteListModal";

type TableRowContextMenuProps = {
  selectedRows: Row<ListType>[];
  onRemoveRows: (rowIds: string[]) => void;
  onRename?: () => void;
};

const TableRowContextMenuLists = ({ selectedRows, onRemoveRows, onRename }: TableRowContextMenuProps) => {
  const { t } = useTranslation();
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [convertModalIsOpen, setConvertModalIsOpen] = useState(false);

  return (
    <>
      <ContextMenuContent>
        {selectedRows.length === 1 && selectedRows[0].original.type === "DYNAMIC" && (
          <ContextMenuItem>
            <button onClick={() => setConvertModalIsOpen(true)} className={"flex items-center gap-2 text-secondary"}>
              <HiOutlineListBullet className={"size-5"} />
              {t("list.convert.title")}
            </button>
          </ContextMenuItem>
        )}
        {selectedRows.length === 1 && (
          <ContextMenuItem>
            <button onClick={() => onRename && onRename()} className={"flex items-center gap-2 text-secondary"}>
              <HiOutlinePencilSquare className={"size-5"} />
              {t("list.update.rename")}
            </button>
          </ContextMenuItem>
        )}
        <ContextMenuItem>
          <button onClick={() => setDeleteModalIsOpen(true)} className={"flex items-center gap-2 text-error"}>
            <HiOutlineTrash className={"size-5"} />
            {t("list.delete.delete", { count: selectedRows.length })}
          </button>
        </ContextMenuItem>
      </ContextMenuContent>
      <Modal
        isOpen={deleteModalIsOpen}
        onClose={() => setDeleteModalIsOpen(false)}
        content={DeleteListModal}
        contentProps={{
          selectedRows,
          onRemoveRows,
        }}
      />
      <Modal
        isOpen={convertModalIsOpen}
        onClose={() => setConvertModalIsOpen(false)}
        content={ConvertListModal}
        contentProps={{
          selectedRow: selectedRows[0],
          onRemoveRows,
        }}
      />
    </>
  );
};

export default TableRowContextMenuLists;
